<template>
  <div class="flex flex-wrap items-center bg-primary">
    <div class="w-full lg:flex-[0_0_50%] lg:max-w-[50%] py-20 lg:py-17">
      <div class="container">
        <div class="mx-auto max-w-[480px]">
          <h1 class="text-white text-center uppercase mb-4">
            {{ pageData.title }}
          </h1>
          <div
            class="text-white ui-text-m text-center mb-8"
            v-html="pageData.description"
          />
          <AuthSignUpForm />
          <div
            class="text-black-60 ui-text-xs max-lg:text-center mt-4"
            v-html="pageData.short_description"
          />
        </div>
      </div>
    </div>
    <div
      class="w-full lg:flex-[0_0_50%] lg:max-w-[50%] lg:h-[800px] max-lg:h-[515px]"
    >
      <UiLazyImg
        class="h-full w-full"
        :src="pageData.image"
        :alt="'Image'"
        cover
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { assetsTypes } from "ecom-types";

const { $api } = useNuxtApp();
const { t } = useI18n();
const { visitEvent } = useEvents();

definePageMeta({
  middleware: ["guest"],
});

const { data } = await useAsyncCachedData("sign-up", () => {
  return $api.pages.getPage("sign-up", {
    skipErrors: [404, 500],
  });
});

const pageData = computed(() => {
  const currentTranslation = data.value?.data?.currentTranslation;
  const usedImagePosition = "page";
  const image = data.value?.data?.medias?.find(
    (item) =>
      item.position === usedImagePosition &&
      item.file?.media_type?.includes(assetsTypes.image),
  );
  return {
    title: currentTranslation?.title || t("welcome"),
    description: currentTranslation?.description || t("pleaseCreateAnAccount"),
    short_description:
      currentTranslation?.short_description ||
      t("bySigningUpForAnAccountYouAcceptOurTerms"),
    image: image?.file?.url || "/images/default-sign-up-img.jpg",
  };
});

onMounted(() => {
  visitEvent();
});
</script>
